import { Country } from '../config/i18nConfig'
import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'
import { useTranslation } from 'react-i18next'
import useGlobalContext from './useGlobalContext'
import { useMemo } from 'react'

type ReturnProps = {
    loaded: boolean
    countries: Country[]
    getCountry: (alpha2: string) => Country
    getCountryName: (id: string) => string
}

export default function useCountries(): ReturnProps {
    const { i18n } = useTranslation()
    const { entities, loaded } = useGlobalContext('countries')

    const countries: Country[] = useMemo(() => entities?.sort((a, b) => (a.position || 1000) - (b.position || 1000)) || [], [entities])

    const getCountry = (alpha2: string) => countries.find(value => value.alpha2 === alpha2)
    const getCountryName = (id: string) =>
        getI18NName(
            countries.find(value => value.alpha2 === id),
            i18n.language,
        )

    return { loaded, countries, getCountry, getCountryName }
}
